import { render, staticRenderFns } from "./ConfigAlertTencentSms.vue?vue&type=template&id=35e47040&"
import script from "./ConfigAlertTencentSms.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertTencentSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports